import React from 'react';
import NavigationBar from '../../../components/intraverse/ui/NavigationBar';

const Header = (props) => <NavigationBar title="Podium Panel" func={props.functinoLogic} />;
export default Header;
